import React from 'react';
import './textInput.css';

class Textinput extends React.Component {

    onChange = (event) => {
        this.props.onChange(event.currentTarget.value);
    };

    render() {
        return (
            <div>
                <input className="textInput" value={this.props.value} onChange={this.onChange} placeholder={this.props.placeholder}/>
            </div>
        );
    }
}

export default Textinput;